'use client';
import React from 'react';
import TopHeader from './TopHeader';
import BottomNav from './BottomNav';
import ToastManager from './ToastManager';
import I18nProvider from './I18nProvider';
import WhatsAppSupport from './WhatsAppSupport';

interface Props {
  children: React.ReactNode;
  hideNav?: boolean;
  hideHeader?: boolean;
}

export default function MobileLayout({ children, hideNav, hideHeader }: Props) {
  return (
    <I18nProvider>
      <div className="relative min-h-screen max-w-md mx-auto overflow-hidden" style={{ background: 'var(--background)' }}>
        {!hideHeader && <TopHeader />}
        <main
          className={`${hideHeader ? '' : 'pt-14'} ${hideNav ? '' : 'content-with-nav'} min-h-screen`}
        >
          {children}
        </main>
        {!hideNav && <BottomNav />}
        <ToastManager />
        <WhatsAppSupport />
      </div>
    </I18nProvider>
  );
}